// Text editor utility functions extracted from OfferPageBuilderSimple.js
// Lines 4627-4738

// Helper function to apply highlight to selected text
export const applyHighlight = (color, editorRef, setTempValue) => {
  if (!editorRef || !editorRef.current) {
    console.log('No editor reference available');
    return;
  }

  const editor = editorRef.current;
  const selection = window.getSelection();

  if (selection.rangeCount === 0 || selection.isCollapsed) {
    console.log('No text selected for highlighting');
    return;
  }

  // Focus the editor first
  editor.focus();

  // Get the range
  const range = selection.getRangeAt(0);

  // Check if the range is within our editor
  if (!editor.contains(range.commonAncestorContainer)) {
    console.log('Selection is not within the editor');
    return;
  }

  try {
    // Create highlight span
    const span = document.createElement('span');
    span.style.backgroundColor = color;
    span.style.padding = '2px 4px';
    span.style.borderRadius = '3px';
    span.style.display = 'inline';

    // Extract and wrap the selected content
    const contents = range.extractContents();
    span.appendChild(contents);
    range.insertNode(span);

    // Clear selection
    selection.removeAllRanges();

    console.log('Highlight applied successfully');

    // Update the tempValue with the new HTML content to prevent reversion
    const newContent = editor.innerHTML;
    setTempValue(newContent);

  } catch (error) {
    console.error('Highlight failed:', error);
  }
};

// Helper function to remove all highlights from the editor
export const removeAllHighlights = (editorRef, setTempValue) => {
  if (!editorRef || !editorRef.current) {
    console.log('No editor reference available');
    return;
  }

  const editor = editorRef.current;
  console.log('Editor HTML before removal:', editor.innerHTML);

  try {
    // Find all highlight spans with different selectors
    const highlightSpans1 = editor.querySelectorAll('span[style*="background-color"]');
    const highlightSpans2 = editor.querySelectorAll('span[style*="background-color:"]');
    const highlightSpans3 = editor.querySelectorAll('span[style*="background-color: #"]');

    // Combine all found spans
    const allSpans = new Set([...highlightSpans1, ...highlightSpans2, ...highlightSpans3]);
    const highlightSpans = Array.from(allSpans);

    console.log(`Found ${highlightSpans.length} highlight spans to remove`);

    if (highlightSpans.length === 0) {
      console.log('No highlights found to remove');
      return;
    }

    // Process each span
    highlightSpans.forEach((span, index) => {
      console.log(`Processing span ${index + 1}:`, span.outerHTML);

      // Create a document fragment to hold the children
      const fragment = document.createDocumentFragment();

      // Move all child nodes to the fragment
      while (span.firstChild) {
        fragment.appendChild(span.firstChild);
      }

      // Insert the fragment before the span
      span.parentNode.insertBefore(fragment, span);

      // Remove the empty span
      span.remove();
    });

    console.log(`Successfully removed ${highlightSpans.length} highlights`);
    console.log('Editor HTML after removal:', editor.innerHTML);

    // Update the tempValue with the cleaned content
    const newContent = editor.innerHTML;
    setTempValue(newContent);

  } catch (error) {
    console.error('Remove highlights failed:', error);
  }
};
